import { Component, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { Utils } from "src/app/shared/utils/utils";
import { Subscription, Subject } from "rxjs";
import { SecteurActiviteService } from "../../services/secteur-activite.service";
import { Router } from "@angular/router";
import { DataTableDirective } from "angular-datatables";
import { DatatablesUtils } from "src/app/shared/datatable-utils";

declare let swal: any;

@Component({
  selector: "app-list-secteur-activite",
  templateUrl: "./list-secteur-activite.component.html",
  styleUrls: ["./list-secteur-activite.component.css"],
})
export class ListSecteurActiviteComponent implements OnInit, OnDestroy {

  secteurs: any[] = [];
  busy: Subscription;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;

  constructor(
    private secteurActiviteService: SecteurActiviteService,
    private router: Router
  ) {}

  ngOnInit() {
    this.initDtOptions();
    setTimeout(() => {
      this.dtTrigger.next(null);
    }, 100);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  // -------------------------------------------------------
  // Init DataTable options
  // -------------------------------------------------------
  initDtOptions(): void {
    this.dtOptions = {
      dom: "['<l>', Bfrtip']",
      buttons: ["colvis"],
      pagingType: "full_numbers",
      pageLength: 10,
      aLengthMenu: [
        [5, 10, 25, 50, 100000],
        [5, 10, 25, 50, "All"],
      ],
      ajax: (dataTablesParameters: any, callback) => {
        this.busy = this.secteurActiviteService.getAll().subscribe(
          (data: any) => {
            this.secteurs = data;
            callback({
              recordsTotal: data.length,
              recordsFiltered: data.length,
              data: this.secteurs,
            });
          },
          () => {
            Utils.sweetAlert("error", "Erreur", "Erreur lors du chargement des secteurs");
          }
        );
      },
      columns: this.getColumns(),
      rowCallback: (row: Node, data: any) => {
        jQuery(".action-btn", row).unbind("click");
        jQuery(".action-btn", row).bind("click", (event) => {
          const actionId = parseInt(
            $(event.target).closest("[action-id]").attr("action-id"),
            10
          );
          this.goToAction(actionId, data);
        });
      },
    };
  }

  // -------------------------------------------------------
  // Colonnes DataTable
  // -------------------------------------------------------
  getColumns() {
    return [
      { data: "id", visible: true },
      {
        data: "nom",
        visible: true,
        render: (data, type, row) => row.nom,
      },
      {
        data: "description",
        visible: true,
        render: (data, type, row) => row.description ?? "-",
      },
      {
        data: "actif",
        visible: true,
        render: (data, type, row) =>
          row.actif
            ? '<span class="badge badge-success">Actif</span>'
            : '<span class="badge badge-danger">Inactif</span>',
      },
      {
        data: "actions",
        visible: true,
        render: () => DatatablesUtils.renderActionsBtn(),
      },
    ];
  }

  // -------------------------------------------------------
  // Actions Edit / Delete
  // -------------------------------------------------------
  private goToAction(actionId: number, data: any) {
    switch (actionId) {
      case 1:
        this.router.navigate(["/secteurs-activite", data.id, "edit"]);
        break;
      case 2:
        this.removeSecteur(data.id);
        break;
    }
  }

  removeSecteur(id: number) {
    swal({
      title: "Êtes-vous sûr ?",
      text: "Cette action est irréversible !",
      icon: "warning",
      buttons: ["Annuler", "Supprimer"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.busy = this.secteurActiviteService.delete(id).subscribe(
          () => {
            Utils.sweetAlert("success", "Succès", "Secteur supprimé avec succès");
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.ajax.reload(null, false);
            });
          },
          () => {
            Utils.sweetAlert("error", "Erreur", "Erreur lors de la suppression");
          }
        );
      }
    });
  }
}